// extracted by mini-css-extract-plugin
export default {"wrapper":"CustomFormikCheckbox_wrapper__gzrF5","error":"CustomFormikCheckbox_error__ezNlb"};